"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  IMAGE: 'marketingImageSmallUrl',
  PRODUCT_NAME: 'name',
  PRODUCT_TYPE: 'subType',
  PURCHASE_DATE: 'createdAt'
};
exports.default = _default;
module.exports = exports.default;